export default __webpack_public_path__ + "static/media/caret.a05c4424.svg";